// src/services/infoWindowService.ts
import { apiService } from './api';
import type { ConversationCard, Layer } from '../types/dashboard';

class InfoWindowService
{
  /**
   * Obtiene la informacion de la card segun el id
   */
  async getConversationById(
    conversationId: number,
    layersToHide: any,
    getAllReplies: boolean,
    isConversarionDetailsView: boolean,
    totalReplies: number,
    isEnabled: boolean,
    isPersonConversation?: boolean,
    homeProfilePersonId?: number,
  ): Promise<ConversationCard>
  {
    try
    {
      let url = `/Conversation/GetConversationById?conversationId=${conversationId}&layersToHide=${layersToHide ?? ''}&getAllReplies=${getAllReplies}&isConversationDetailsView=${isConversarionDetailsView}&totalReplies=${totalReplies}&isEnabled=${isEnabled}`;

      if (isPersonConversation !== undefined)
      {
        url += `&isPersonConversation=${isPersonConversation}`;
      }

      if (homeProfilePersonId !== undefined)
      {
        url += `&homeProfilePersonId=${homeProfilePersonId}`;
      }

      const response = await apiService.post<ConversationCard>(url);
      return response;
    }
    catch (error)
    {
      console.error('Error posting conversation by id:', error);
      throw error;
    }
  }

  async getCustomFieldsByItemId(
    CoreTaskId: number,
    IsDeleted: boolean,
    ProjectId: number,
    IsAllPhaseResume: boolean | null,
  ): Promise<Layer[]>
  {
    try
    {
      const response = await apiService.get<Layer[]>(
        `/CustomField/GetCustomFieldsByItemId?CoreTaskId=${CoreTaskId}&IsDeleted=${IsDeleted}&ProjectId=${ProjectId}&IsAllPhaseResume=${IsAllPhaseResume ?? undefined}`,
      );
      return response;
    }
    catch (error)
    {
      console.error('Error getting custom fields by item id:', error);
      throw error;
    }
  }
}

export const infoWindowService = new InfoWindowService();
